import { useParams } from 'react-router';
import LibraryLanding from './LibraryLanding';
import LibraryDetail from './LibraryDetail';

export type LibraryPageModeProps = {
  isPublic?: boolean;
  basePath?: string;
};

export default function Library({ isPublic = false, basePath = '/library' }: LibraryPageModeProps) {
  const { id } = useParams<{ id: string }>();
  if (id) return <LibraryDetail isPublic={isPublic} basePath={basePath} />;
  return <LibraryLanding isPublic={isPublic} basePath={basePath} />;
}
